"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lens_1 = require("./../lens");

var utils_1 = require("./../utils");

var rxjs_1 = require("rxjs");

var AbstractReadOnlyAtom =
/** @class */
function (_super) {
  __extends(AbstractReadOnlyAtom, _super);

  function AbstractReadOnlyAtom() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  AbstractReadOnlyAtom.prototype.view = function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    } // tslint:disable no-use-before-declare


    return args[0] !== undefined // view(getter) case
    ? typeof args[0] === 'function' ? new AtomViewImpl(this, args[0]) // view('key') case
    : typeof args[0] === 'string' ? new AtomViewImpl(this, lens_1.Lens.compose.apply(lens_1.Lens, args.map(lens_1.Lens.key())).get) // view(lens) and view(prism) cases
    // @NOTE single case handles both lens and prism arg
    : new AtomViewImpl(this, function (x) {
      return args[0].get(x);
    }) // view() case
    : this; // tslint:enable no-use-before-declare
  };

  return AbstractReadOnlyAtom;
}(rxjs_1.BehaviorSubject);

exports.AbstractReadOnlyAtom = AbstractReadOnlyAtom;

var AbstractAtom =
/** @class */
function (_super) {
  __extends(AbstractAtom, _super);

  function AbstractAtom() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  AbstractAtom.prototype.set = function (x) {
    this.modify(function () {
      return x;
    });
  };

  AbstractAtom.prototype.lens = function (arg1) {
    // tslint:disable no-use-before-declare
    var args = [];

    for (var _i = 1; _i < arguments.length; _i++) {
      args[_i - 1] = arguments[_i];
    } // lens(prop expr) case


    return typeof arg1 === 'function' ? new LensedAtom(this, lens_1.Lens.prop(arg1), utils_1.structEq) // lens('key') case
    : typeof arg1 === 'string' ? new LensedAtom(this, lens_1.Lens.compose.apply(lens_1.Lens, [lens_1.Lens.key(arg1)].concat(args.map(function (k) {
      return lens_1.Lens.key(k);
    }))), utils_1.structEq) // lens(lens) case
    : new LensedAtom(this, arg1, utils_1.structEq); // tslint:enable no-use-before-declare
  };

  return AbstractAtom;
}(AbstractReadOnlyAtom);

exports.AbstractAtom = AbstractAtom;

var JsonAtom =
/** @class */
function (_super) {
  __extends(JsonAtom, _super);

  function JsonAtom(initialValue) {
    return _super.call(this, initialValue) || this;
  }

  JsonAtom.prototype.get = function () {
    return this.getValue();
  };

  JsonAtom.prototype.modify = function (updateFn) {
    var prevValue = this.getValue();
    var next = updateFn(prevValue);
    if (!utils_1.structEq(prevValue, next)) this.next(next);
  };

  JsonAtom.prototype.set = function (x) {
    var prevValue = this.getValue();
    if (!utils_1.structEq(prevValue, x)) this.next(x);
  };

  return JsonAtom;
}(AbstractAtom);

exports.JsonAtom = JsonAtom;

var LensedAtom =
/** @class */
function (_super) {
  __extends(LensedAtom, _super);

  function LensedAtom(_source, _lens, _eq) {
    if (_eq === void 0) {
      _eq = utils_1.structEq;
    }

    var _this = // @NOTE this is a major hack to optimize for not calling
    // _lens.get the extra time here. This makes the underlying
    // BehaviorSubject to have an `undefined` for it's current value.
    //
    // But it works because before somebody subscribes to this
    // atom, it will subscribe to the _source (which we expect to be a
    // descendant of BehaviorSubject as well), which will emit a
    // value right away, triggering our _onSourceValue.
    _super.call(this, undefined) || this;

    _this._source = _source;
    _this._lens = _lens;
    _this._eq = _eq;
    _this._subscription = null;
    _this._refCount = 0;
    return _this;
  }

  LensedAtom.prototype.get = function () {
    // Optimization: in case we're already subscribed to the
    // source atom, the BehaviorSubject.getValue will return
    // an up-to-date computed lens value.
    //
    // This way we don't need to recalculate the lens value
    // every time.
    return this._subscription ? this.getValue() : this._lens.get(this._source.get());
  };

  LensedAtom.prototype.modify = function (updateFn) {
    var _this = this;

    this._source.modify(function (x) {
      return _this._lens.modify(updateFn, x);
    });
  };

  LensedAtom.prototype.set = function (newValue) {
    var _this = this;

    this._source.modify(function (x) {
      return _this._lens.set(newValue, x);
    });
  };

  LensedAtom.prototype._onSourceValue = function (x) {
    var prevValue = this.getValue();

    var next = this._lens.get(x);

    if (!this._eq(prevValue, next)) this.next(next);
  }; // Rx method overrides


  LensedAtom.prototype._subscribe = function (subscriber) {
    var _this = this;

    if (!this._subscription) {
      this._subscription = this._source.subscribe(function (x) {
        return _this._onSourceValue(x);
      });
    }

    this._refCount++;
    var sub = new rxjs_1.Subscription(function () {
      if (--_this._refCount <= 0 && _this._subscription) {
        _this._subscription.unsubscribe();

        _this._subscription = null;
      }
    });
    sub.add(_super.prototype._subscribe.call(this, subscriber));
    return sub;
  };

  LensedAtom.prototype.unsubscribe = function () {
    if (this._subscription) {
      this._subscription.unsubscribe();

      this._subscription = null;
    }

    this._refCount = 0;

    _super.prototype.unsubscribe.call(this);
  };

  return LensedAtom;
}(AbstractAtom);

var AtomViewImpl =
/** @class */
function (_super) {
  __extends(AtomViewImpl, _super);

  function AtomViewImpl(_source, _getter, _eq) {
    if (_eq === void 0) {
      _eq = utils_1.structEq;
    }

    var _this = // @NOTE this is a major hack to optimize for not calling
    // _getter the extra time here. This makes the underlying
    // BehaviorSubject to have an `undefined` for it's current value.
    //
    // But it works because before somebody subscribes to this
    // atom, it will subscribe to the _source (which we expect to be a
    // descendant of BehaviorSubject as well), which will emit a
    // value right away, triggering our _onSourceValue.
    _super.call(this, undefined) || this;

    _this._source = _source;
    _this._getter = _getter;
    _this._eq = _eq;
    _this._subscription = null;
    _this._refCount = 0;
    return _this;
  }

  AtomViewImpl.prototype.get = function () {
    // Optimization: in case we're already subscribed to the
    // source atom, the BehaviorSubject.getValue will return
    // an up-to-date computed lens value.
    //
    // This way we don't need to recalculate the view value
    // every time.
    return this._subscription ? this.getValue() : this._getter(this._source.get());
  };

  AtomViewImpl.prototype._onSourceValue = function (x) {
    var prevValue = this.getValue();

    var next = this._getter(x);

    if (!this._eq(prevValue, next)) this.next(next);
  }; // Rx method overrides


  AtomViewImpl.prototype._subscribe = function (subscriber) {
    var _this = this;

    if (!this._subscription) {
      this._subscription = this._source.subscribe(function (x) {
        return _this._onSourceValue(x);
      });
    }

    this._refCount++;
    var sub = new rxjs_1.Subscription(function () {
      if (--_this._refCount <= 0 && _this._subscription) {
        _this._subscription.unsubscribe();

        _this._subscription = null;
      }
    });
    sub.add(_super.prototype._subscribe.call(this, subscriber));
    return sub;
  };

  AtomViewImpl.prototype.unsubscribe = function () {
    if (this._subscription) {
      this._subscription.unsubscribe();

      this._subscription = null;
    }

    this._refCount = 0;

    _super.prototype.unsubscribe.call(this);
  };

  return AtomViewImpl;
}(AbstractReadOnlyAtom);

var CombinedAtomViewImpl =
/** @class */
function (_super) {
  __extends(CombinedAtomViewImpl, _super);

  function CombinedAtomViewImpl(_sources, _combineFn, _eq) {
    if (_eq === void 0) {
      _eq = utils_1.structEq;
    }

    var _this = // @NOTE this is a major hack to optimize for not calling
    // _combineFn and .get for each source the extra time here.
    // This makes the underlying BehaviorSubject to have an
    // `undefined` for it's current value.
    //
    // But it works because before somebody subscribes to this
    // atom, it will subscribe to the _source (which we expect to be a
    // descendant of BehaviorSubject as well), which will emit a
    // value right away, triggering our _onSourceValue.
    _super.call(this, undefined) || this;

    _this._sources = _sources;
    _this._combineFn = _combineFn;
    _this._eq = _eq;
    _this._subscription = null;
    _this._refCount = 0;
    return _this;
  }

  CombinedAtomViewImpl.prototype.get = function () {
    // Optimization: in case we're already subscribed to
    // source atoms, the BehaviorSubject.getValue will return
    // an up-to-date computed view value.
    //
    // This way we don't need to recalculate the view value
    // every time.
    return this._subscription ? this.getValue() : this._combineFn(this._sources.map(function (x) {
      return x.get();
    }));
  };

  CombinedAtomViewImpl.prototype._onSourceValues = function (xs) {
    var prevValue = this.getValue();

    var next = this._combineFn(xs);

    if (!this._eq(prevValue, next)) this.next(next);
  }; // Rx method overrides


  CombinedAtomViewImpl.prototype._subscribe = function (subscriber) {
    var _this = this;

    if (!this._subscription) {
      this._subscription = rxjs_1.combineLatest(this._sources).subscribe(function (xs) {
        return _this._onSourceValues(xs);
      });
    }

    this._refCount++;
    var sub = new rxjs_1.Subscription(function () {
      if (--_this._refCount <= 0 && _this._subscription) {
        _this._subscription.unsubscribe();

        _this._subscription = null;
      }
    });
    sub.add(_super.prototype._subscribe.call(this, subscriber));
    return sub;
  };

  CombinedAtomViewImpl.prototype.unsubscribe = function () {
    if (this._subscription) {
      this._subscription.unsubscribe();

      this._subscription = null;
    }

    this._refCount = 0;

    _super.prototype.unsubscribe.call(this);
  };

  return CombinedAtomViewImpl;
}(AbstractReadOnlyAtom);

exports.CombinedAtomViewImpl = CombinedAtomViewImpl;